import BlockFormatNormalizationsPluginFactory from '../Blocks/BlockFormatNormalizationsPluginFactory';

export const infoBlockNormalizationPlugin =
  BlockFormatNormalizationsPluginFactory('infoBlock');

export const warningBlockNormalizationPlugin =
  BlockFormatNormalizationsPluginFactory('warningBlock');

export const tipBlockNormalizationPlugin =
  BlockFormatNormalizationsPluginFactory('tipBlock');

export const noteBlockNormalizationPlugin =
  BlockFormatNormalizationsPluginFactory('noteBlock');

const InfoBlockNormalizationsPlugin = [
  infoBlockNormalizationPlugin,
  warningBlockNormalizationPlugin,
  tipBlockNormalizationPlugin,
  noteBlockNormalizationPlugin,
];

export default InfoBlockNormalizationsPlugin;
